import { Pipe, PipeTransform, inject } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { LoggerService } from '@app/core/infrastructure';
import { markdownToSubtitleHtml } from '@app/utils/markdown.utils';

@Pipe({
  name: 'markdown',
  standalone: true
})
export class MarkdownPipe implements PipeTransform {
  private readonly logger = inject(LoggerService).scope('MarkdownPipe');

  constructor(
    private readonly sanitizer: DomSanitizer
  ) { }

  transform(value: string | null | undefined): SafeHtml {
    if (!value || typeof value !== 'string') {
      return '';
    }

    try {
      // Use subtitle-optimized markdown conversion
      // Strips block-level markdown (headings, code blocks, multiple newlines)
      // Keeps only inline formatting (bold, italic, strikethrough)
      const html = markdownToSubtitleHtml(value);
      return this.sanitizer.bypassSecurityTrustHtml(html);
    } catch (error) {
      this.logger.warn('Error parsing markdown:', error);
      // Fallback: return plain text with all markdown stripped
      return this.sanitizer.bypassSecurityTrustHtml(
        value
          .replace(/[#*_~`\[\]()]/g, '')
          .replace(/\n+/g, ' ')
          .trim()
      );
    }
  }
}
